import React from 'react';

import Form from "../Form";



const SurveyTemplateNewView = ({campaignTemplateId, onSuccess = () => null, onSubmitting = () => null, onError = () => null}) => 
  <Form campaignTemplateId={campaignTemplateId} surveyTemplate={{surveyTemplateCampaignTemplateId: campaignTemplateId}} onSubmitting={onSubmitting} onError={onError} onSuccess={onSuccess} />

export default SurveyTemplateNewView;